export const API_ERROR = "profile_api_failed";
export const GET_PERMSTIONS_LIST = "profile_Get_Permissions_List";
export const GET_PERMSTIONS_LIST_SUCCESSFULL =
  "profile_Get_Permstions_List_Successful";

export const CHECK_PERMSSION = "Profile_check_permssion";
export const CHECK_PERMSSION_FILED = "Profile_check_permission_filed";
export const SUBMIT_PROFILE = "profile_submit_profile";

export const GET_PROFILE_DATA = "profile_Get_profiles_data";
export const GET_PROFILE_DATA_SUCCESSFULL =
  "profile_Get_profiles_data_Successful";
export const INPUT_CHANGEVALUE = "profile_input_changeValue";
